
import React, { useState } from "react";

function ForwardModal({ contacts = [], groups = [], forwardMsg, forwarding, onSend, onClose }) {
  const [selected, setSelected] = useState([]);
  const [search,   setSearch]   = useState("");

  const toggle = (id, type = "contact") =>
    setSelected(prev =>
      prev.some(s => s.id === id && s.type === type)
        ? prev.filter(s => !(s.id === id && s.type === type))
        : [...prev, { id, type }]
    );

  // Combine contacts and groups with type markers
  const allItems = [
    ...contacts.map(c => ({ ...c, id: c.emails?.[0], type: "contact", displayName: c.name, displayEmail: c.emails?.[0] })),
    ...groups.map(g => ({ ...g, id: g.id, type: "group", displayName: g.name, displayEmail: null })),
  ];

  const filtered = allItems.filter(item => {
    const q = search.toLowerCase();
    return (
      (item.displayName || "").toLowerCase().includes(q) ||
      (item.displayEmail || "").toLowerCase().includes(q)
    );
  });

  if (!forwardMsg) return null;

  return (
    <div
      className="contacts-form-overlay"
      onClick={onClose}
    >
      <div
        className="contacts-form"
        style={{ maxWidth: 440 ,width: "95% !important" }}
        onClick={e => e.stopPropagation()}
      >
        <h3 className="form-title">↪ Forward Message</h3>

        {/* ── Message preview ─────────────────────────────────────────────── */}
        <div style={{
          margin: "0 0 14px",
          padding: "10px 14px",
          background: "#f8fafc",
          borderRadius: 8,
          border: "1px solid #e2e8f0",
          fontSize: 13,
          color: "#475569",
          maxHeight: 70,
          overflow: "hidden",
        }}>
          <span style={{ fontSize: 11, color: "#94a3b8", display: "block", marginBottom: 3 }}>
            Forwarding:
          </span>
          {forwardMsg.text || (forwardMsg.url ? "📎 Media" : "—")}
        </div>

        {/* ── Selected chips ──────────────────────────────────────────────── */}
        {selected.length > 0 && (
          <div style={{
            display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 10,
          }}>
            {selected.map(sel => {
              const item = allItems.find(i => i.id === sel.id && i.type === sel.type);
              const name = item?.displayName || (sel.type === "group" ? "Group" : sel.id);
              return (
                <span
                  key={`${sel.type}-${sel.id}`}
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 4,
                    background: sel.type === "group" ? "#f0f4f8" : "#eff6ff",
                    color: sel.type === "group" ? "#334155" : "#1e40af",
                    borderRadius: 20, padding: "3px 10px",
                    fontSize: 12, border: sel.type === "group" ? "1px solid #cbd5e1" : "1px solid #bfdbfe",
                  }}
                >
                  {sel.type === "group" ? "👥 " : ""}{name}
                  <span
                    style={{ cursor: "pointer", fontWeight: 700 }}
                    onClick={() => toggle(sel.id, sel.type)}
                  >
                    ×
                  </span>
                </span>
              );
            })}
          </div>
        )}

        {/* ── Search ──────────────────────────────────────────────────────── */}
        <div className="input-group" style={{ marginBottom: 10 }}>
          <input
            type="text"
            placeholder=" "
            value={search}
            onChange={e => setSearch(e.target.value)}
            autoFocus
          />
          <label>Search contacts</label>
        </div>

        {/* ── Contact/Group list ──────────────────────────────────────────── */}
        <div style={{
          maxHeight: 280, overflowY: "auto",
          display: "flex", flexDirection: "column", gap: 4,
          marginBottom: 14,
        }}>
          {filtered.length === 0 && (
            <p style={{
              color: "#94a3b8", fontSize: 13,
              textAlign: "center", padding: 16,
            }}>
              No contacts or groups found
            </p>
          )}

          {filtered.map(item => {
            const isChosen = selected.some(s => s.id === item.id && s.type === item.type);
            const isGroup = item.type === "group";

            return (
              <div
                key={`${item.type}-${item.id}`}
                onClick={() => toggle(item.id, item.type)}
                style={{
                  display: "flex", alignItems: "center", gap: 12,
                  padding: "9px 12px", borderRadius: 8, cursor: "pointer",
                  border:     `1px solid ${isChosen ? (isGroup ? "#cbd5e1" : "#bfdbfe") : "#f1f5f9"}`,
                  background: isChosen ? (isGroup ? "#f0f4f8" : "#eff6ff") : "transparent",
                  transition: "background .1s, border .1s",
                }}
              >
                {/* Avatar — checkmark when selected */}
                <div style={{
                  width: 36, height: 36, borderRadius: isGroup ? 6 : "50%", flexShrink: 0,
                  background: isChosen ? (isGroup ? "#64748b" : "#1e40af") : "#e2e8f0",
                  color:      isChosen ? "#fff"    : "#475569",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontWeight: 600, fontSize: 15,
                  transition: "background .15s, color .15s",
                }}>
                  {isChosen ? "✔" : (isGroup ? "👥" : item.displayName.charAt(0).toUpperCase())}
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 500, fontSize: 14 }}>
                    {isGroup && "👥 "}{item.displayName}
                  </div>
                  {item.displayEmail && (
                    <div style={{
                      fontSize: 12, color: "#94a3b8",
                      overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                    }}>
                      {item.displayEmail}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* ── Buttons ──────────────────────────────────────────────────────── */}
        <div className="form-buttons">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-primary"
            disabled={selected.length === 0 || forwarding}
            style={{ opacity: selected.length === 0 ? 0.5 : 1 }}
            onClick={() => {
              const toContacts = selected
                .filter(s => s.type === "contact")
                .map(s => contacts.find(c => c.emails?.[0] === s.id))
                .filter(Boolean);
              const toGroups = selected
                .filter(s => s.type === "group")
                .map(s => groups.find(g => g.id === s.id))
                .filter(Boolean);
              onSend({ contacts: toContacts, groups: toGroups });
            }}
          >
            {forwarding
              ? "Sending…"
              : `Send to ${selected.length} ${selected.length === 1 ? "recipient" : "recipients"}`}
          </button>
        </div>

      </div>
    </div>
  );
}

export default ForwardModal;
